<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Detail Brand</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="information-group pb-5">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Brand Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col">
              <p class="mb-0">Brand Code *</p>
              <input
                type="text"
                v-model="form.brandCode"
                class="form-control"
                :disabled="!!this.$route.query.brandCode"
                :class="{
                  'input--error': isSubmit && error.errorBrandCode,
                }"
              />
              <div v-if="isSubmit && error.errorBrandCode" class="text-error">
                {{ error.errorBrandCode.message }}
              </div>
            </div>
            <div class="col">
              <p class="mb-0">Brand Name *</p>
              <input
                type="text"
                v-model="form.brandName"
                class="form-control"
                :class="{
                  'input--error': isSubmit && error.errorBrandName,
                }"
              />
              <div v-if="isSubmit && error.errorBrandName" class="text-error">
                {{ error.errorBrandName.message }}
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-2">
              <input
                id="flexCheckDefault"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.isActive"
                :class="{
                  'input--error': isSubmit && error.errorStatus,
                }"
              />
              <label class="form-check-label" for="flexCheckDefault">
                Active
              </label>
              <div v-if="isSubmit && error.errorStatus" class="text-error">
                {{ error.errorStatus.message }}
              </div>
            </div>
            <div class="col-4">
              <input
                id="checkHasPoint"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.isHasPointCollection"
              />
              <label class="form-check-label" for="checkHasPoint">
                Has point collection
              </label>
            </div>
            <div class="col-4">
              <input
                id="checkShowMembership"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.showMembershipCard"
              />
              <label class="form-check-label" for="checkShowMembership">
                Show membership card on B-Con
              </label>
            </div>
          </div>
          <p class="label-title">Logo information</p>
          <div class="row">
            <div class="col-6 pt-0">
              <input
                type="file"
                @change="uploadLogoImage"
                ref="logoImageFile"
                class="form-control"
                accept="image/*"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <img
                id="previewLogo"
                v-if="previewLogo"
                :src="previewLogo"
                style="background-color: #000000; padding: 10px"
                alt=""
              />
              <button
                v-if="previewLogo"
                class="btn btn-outline-danger btn-del ml-5"
                @click="deleteLogoImage()"
              >
                Delete
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="mb-0">Display order</p>
              <NumberInput v-model="form.logoDisplayOrder" dynamic-class="mr-2"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="mb-0">Target url</p>
              <input
                class="form-control mr-2"
                type="text"
                v-model="form.logoTargetUrl"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Online Stores</div>
        </div>
        <div class="px-6 py-3">
          <p class="label-title">1. Lazada</p>
          <div class="row">
            <div class="col-4">
              <input
                  id="allowLazadaBills"
                  class="form-check-input mr-2"
                  type="checkbox"
                  v-model="form.allowLazadaBills"
              />
              <label class="form-check-label" for="allowLazadaBills">
                Allow adding Lazada bills
              </label>
            </div>
            <div class="col-4" style="margin-top: -24px;">
              <p class="mb-0">Lazada store code</p>
              <input
                  class="form-control mr-2"
                  type="text"
                  v-model="form.lazadaCode"
                  :class="{
                  'input--error': isSubmit && error.errorLazadaStoreCode,
                }"
              />
              <div
                  v-if="isSubmit && error.errorLazadaStoreCode"
                  class="text-error"
              >
                {{ error.errorLazadaStoreCode.message }}
              </div>
            </div>
            <div class="col-4"></div>
          </div>
          <p class="label-title mt-3">2. Shopee</p>
          <div class="row">
            <div class="col-4">
              <input
                  id="allowShopeeBills"
                  class="form-check-input mr-2"
                  type="checkbox"
                  v-model="form.allowShopeeBills"
              />
              <label class="form-check-label" for="allowShopeeBills">
                Allow adding Shopee bills
              </label>
            </div>
            <div class="col-4" style="margin-top: -24px;">
              <p class="mb-0">Shopee store code</p>
              <input
                  class="form-control mr-2"
                  type="text"
                  v-model="form.shopeeCode"
                  :class="{
                  'input--error': isSubmit && error.errorShopeeStoreCode,
                }"
              />
              <div
                  v-if="isSubmit && error.errorShopeeStoreCode"
                  class="text-error"
              >
                {{ error.errorShopeeStoreCode.message }}
              </div>
            </div>
            <div class="col-4"></div>
          </div>
          <p class="label-title mt-3">3. Brand.com</p>
          <div class="row">
            <div class="col-4">
              <input
                  id="allowOfficialWebsiteBills"
                  class="form-check-input mr-2"
                  type="checkbox"
                  v-model="form.allowOfficialWebsiteBills"
              />
              <label class="form-check-label" for="allowOfficialWebsiteBills">
                Allow adding bills from Brand.com
              </label>
            </div>
            <div class="col-4" style="margin-top: -24px;">
              <p class="mb-0">Brand.com store code</p>
              <input
                  class="form-control mr-2"
                  type="text"
                  v-model="form.officialWebsiteStoreCode"
                  :class="{
                  'input--error':
                    isSubmit && error.errorOfficialWebsiteStoreCode,
                }"
              />
              <div
                  v-if="isSubmit && error.errorOfficialWebsiteStoreCode"
                  class="text-error"
              >
                {{ error.errorOfficialWebsiteStoreCode.message }}
              </div>
            </div>
            <div class="col-4"></div>
          </div>
          <div class="row mt-2" v-if="form.allowOfficialWebsiteBills">
            <div class="col-4">
              <p class="mb-0">Brand.com start date</p>
              <date-picker
                  v-bind="$attrs"
                  v-model="form.officialWebsiteStartDate"
                  format="DD/MM/YYYY"
                  :value="form.officialWebsiteStartDate"
                  :lang="'en'"
                  @change="form.officialWebsiteStartDate = $event"
                  :class="{
                  'input--error':
                    isSubmit && error.errorOfficialWebsiteStartDate,
                }"
              />
              <div
                  v-if="isSubmit && error.errorOfficialWebsiteStartDate"
                  class="text-error"
              >
                {{ error.errorOfficialWebsiteStartDate.message }}
              </div>
            </div>
            <div class="col-4">
              <p class="mb-0">Brand.com end date</p>
              <date-picker
                  v-bind="$attrs"
                  v-model="form.officialWebsiteEndDate"
                  format="DD/MM/YYYY"
                  :value="form.officialWebsiteEndDate"
                  :lang="'en'"
                  @change="form.officialWebsiteEndDate = $event"
                  :class="{
                  'input--error': isSubmit && error.errorOfficialWebsiteEndDate,
                }"
              />
              <div
                  v-if="isSubmit && error.errorOfficialWebsiteEndDate"
                  class="text-error"
              >
                {{ error.errorOfficialWebsiteEndDate.message }}
              </div>
            </div>
            <div class="col-4"></div>
          </div>
          <div class="row" v-if="form.allowOfficialWebsiteBills">
            <div class="col-4" style="margin-top: 24px;">
              <input
                  id="enableOfficialWebsiteMapping"
                  class="form-check-input mr-2"
                  type="checkbox"
                  v-model="form.enableOfficialWebsiteMapping"
              />
              <label class="form-check-label" for="enableOfficialWebsiteMapping">
                Enable auto sync orders
              </label>
              <div
                  v-if="isSubmit && error.errorEnableOfficialWebsiteMapping"
                  class="text-error"
              >
                {{ error.errorEnableOfficialWebsiteMapping.message }}
              </div>
            </div>
            <div class="col-4">
              <p class="mb-0">Auto sync start date</p>
              <date-picker
                  style="margin-top: -12px;"
                  v-bind="$attrs"
                  v-model="form.officialWebsiteMappingStartDate"
                  format="DD/MM/YYYY"
                  :value="form.officialWebsiteMappingStartDate"
                  :lang="'en'"
                  @change="form.officialWebsiteMappingStartDate = $event"
                  :class="{
                  'input--error': isSubmit && error.officialWebsiteMappingStartDate,
                }"
              />
              <div
                  v-if="isSubmit && error.errorOfficialWebsiteMappingStartDate"
                  class="text-error"
              >
                {{ error.errorOfficialWebsiteMappingStartDate.message }}
              </div>
            </div>
            <div class="col-4">
              <p class="mb-0">Auto sync brand code</p>
              <input
                  class="form-control mr-2"
                  type="text"
                  v-model="form.officialWebsiteBrandCode"
                  :class="{
                  'input--error':
                    isSubmit && error.errorOfficialWebsiteBrandCode,
                }"
              />
              <div
                  v-if="isSubmit && error.errorOfficialWebsiteBrandCode"
                  class="text-error"
              >
                {{ error.errorOfficialWebsiteBrandCode.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Redemption</div>
        </div>
        <div class="px-6 py-3">
          <p class="label-title mb-0 mt-5">Yearend redemption</p>
          <div class="row">
            <div class="col">
              <p class="mb-0">Yearend redemption start date</p>
              <date-picker
                v-bind="$attrs"
                v-model="form.redemptionStartDate"
                format="DD/MM/YYYY"
                :value="form.redemptionStartDate"
                :lang="'en'"
                @change="form.redemptionStartDate = $event"
                :class="{
                  'input--error': isSubmit && error.errorStartDate,
                }"
              />
              <div v-if="isSubmit && error.errorStartDate" class="text-error">
                {{ error.errorStartDate.message }}
              </div>
            </div>
            <div class="col">
              <p class="mb-0">Yearend redemption end date</p>
              <date-picker
                v-bind="$attrs"
                v-model="form.redemptionEndDate"
                format="DD/MM/YYYY"
                :value="form.redemptionEndDate"
                :lang="'en'"
                @change="form.redemptionEndDate = $event"
                :class="{
                  'input--error': isSubmit && error.errorEndDate,
                }"
              />
              <div v-if="isSubmit && error.errorEndDate" class="text-error">
                {{ error.errorEndDate.message }}
              </div>
            </div>
            <div class="col">
              <p class="mb-0">Point year</p>
              <multiselect
                class="point-year-select"
                v-model="form.yearSelect"
                :options="pointYearOptions"
                placeholder="เลือก Point year"
              >
              </multiselect>
            </div>
            <div class="col" style="align-self: end">
              <input
                id="highestStepRequiredForYearEnd"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.highestStepRequiredForYearEnd"
              />
              <label
                class="form-check-label"
                for="highestStepRequiredForYearEnd"
              >
                Highest step is required
              </label>
            </div>
          </div>
          <p class="label-title mt-8 mb-0">Catalog redemption</p>
          <div class="row">
            <div class="col" style="align-self: end">
              <input
                id="highestStepRequiredForCatalog"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.highestStepRequiredForCatalog"
              />
              <label
                class="form-check-label"
                for="highestStepRequiredForCatalog"
              >
                Highest step is required
              </label>
            </div>
          </div>
          <p class="label-title mt-8 mb-0">Redemption</p>
          <div class="row">
            <div class="col">
              <p class="mb-0">Redemption image (965 x 370 px)</p>
              <div class="row">
                <div class="col-6 pt-0">
                  <input
                    type="file"
                    @change="uploadRedemptionImage"
                    ref="redempImageFile"
                    class="form-control"
                    accept="image/*"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <img
                    id="previewRedemp"
                    v-if="previewRedemption"
                    :src="previewRedemption"
                    alt=""
                  />
                  <button
                    v-if="previewRedemption"
                    class="btn btn-outline-danger btn-del ml-5 mb-0 mt-6"
                    @click="deleteRedemptionImage()"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Service Reservation</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col-3">
              <p class="mb-0">Maximum advanced booking in days</p>
              <NumberInput
                v-model="form.maxAdvanceBookingDays"
                :dynamic-class="{
                  'input--error': isSubmit && error.errorMaxAdvanceBookingDays,
                }"
                :is-decimal-allowed="true"
              />
              <div
                v-if="isSubmit && error.errorMaxAdvanceBookingDays"
                class="text-error"
              >
                {{ error.errorMaxAdvanceBookingDays.message }}
              </div>
            </div>
            <div class="col-3">
              <p class="mb-0">Minimum booking update in hours</p>
              <NumberInput
                v-model="form.minBookingUpdateHours"
                :dynamic-class="{
                  'input--error': isSubmit && error.errorMinBookingUpdateHours,
                }"
                :is-decimal-allowed="true"
              />
              <div
                v-if="isSubmit && error.errorMinBookingUpdateHours"
                class="text-error"
              >
                {{ error.errorMinBookingUpdateHours.message }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-2" style="align-self: center">
              <input
                id="isBookingBanEnable"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.isBookingBanEnable"
              />
              <label class="form-check-label" for="isBookingBanEnable">
                Apply penalty
              </label>
            </div>
          </div>
          <div
            class="row"
            id="bookingBanEnable"
            v-show="form.isBookingBanEnable"
          >
            <div class="col-3">
              <p class="mb-0">Cancel limit per period</p>
              <NumberInput
                v-model="form.cancelLimitPerPeriod"
                :dynamic-class="{
                  'input--error': isSubmit && error.errorCancelLimitPerPeriod,
                }"
              />
              <div
                v-if="isSubmit && error.errorCancelLimitPerPeriod"
                class="text-error"
              >
                {{ error.errorCancelLimitPerPeriod.message }}
              </div>
            </div>
            <div class="col-3">
              <p class="mb-0">Cancel limit period in days</p>
              <NumberInput
                v-model="form.cancelLimitPeriodInDays"
                :dynamic-class="{
                  'input--error':
                    isSubmit && error.errorCancelLimitPeriodInDays,
                }"
              />
              <div
                v-if="isSubmit && error.errorCancelLimitPeriodInDays"
                class="text-error"
              >
                {{ error.errorCancelLimitPeriodInDays.message }}
              </div>
            </div>
            <div class="col-3">
              <p class="mb-0">Block booking period in days</p>
              <NumberInput
                v-model="form.bookingBanDays"
                :dynamic-class="{
                  'input--error': isSubmit && error.errorBookingBanDays,
                }"
                :is-decimal-allowed="true"
              />
              <div
                v-if="isSubmit && error.errorBookingBanDays"
                class="text-error"
              >
                {{ error.errorBookingBanDays.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Membership Tiers</div>
        </div>
        <div class="px-6 py-3">
          <div class="row mb-5">
            <div class="col">
              <p class="mb-0">Membership tier start date</p>
              <date-picker
                v-bind="$attrs"
                v-model="form.membershipTierStartDate"
                format="DD/MM/YYYY"
                :value="form.membershipTierStartDate"
                :lang="'en'"
                @change="form.membershipTierStartDate = $event"
                :class="{
                  'input--error':
                    isSubmit && error.errorMembershipTierStartDate,
                }"
              />
              <div
                v-if="isSubmit && error.errorMembershipTierStartDate"
                class="text-error"
              >
                {{ error.errorMembershipTierStartDate.message }}
              </div>
            </div>
            <div class="col">
              <p class="mb-0">12-month rolling start date</p>
              <date-picker
                v-bind="$attrs"
                v-model="form.membershipTier12MonthRollingStartDate"
                format="DD/MM/YYYY"
                :value="form.membershipTier12MonthRollingStartDate"
                :lang="'en'"
                @change="form.membershipTier12MonthRollingStartDate = $event"
                :class="{
                  'input--error':
                    isSubmit &&
                    error.errorMembershipTier12MonthRollingStartDate,
                }"
              />
              <div
                v-if="
                  isSubmit && error.errorMembershipTier12MonthRollingStartDate
                "
                class="text-error"
              >
                {{ error.errorMembershipTier12MonthRollingStartDate.message }}
              </div>
            </div>
          </div>
          <p class="label-title mb-0">Membership vouchers</p>
          <div class="row">
            <div class="col-2" style="align-self: end">
              <input
                id="isMembershipVoucher"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.isMembershipVoucherEnabled"
                :class="{
                  'input--error':
                    isSubmit && error.errorMembershipVoucherEnabled,
                }"
              />
              <label class="form-check-label" for="isMembershipVoucher">
                Enabled
              </label>
              <div
                v-if="isSubmit && error.errorMembershipVoucherEnabled"
                class="text-error"
              >
                {{ error.errorMembershipVoucherEnabled.message }}
              </div>
            </div>
          </div>
          <p class="label-title mt-8 mb-0">Membership status progression</p>
          <div class="row">
            <div class="col">
              <input
                id="isShowBrandNameInProgressMessage"
                class="form-check-input mr-2"
                type="checkbox"
                v-model="form.isShowBrandNameInProgressMessage"
                :class="{
                  'input--error':
                    isSubmit && error.errorIsShowBrandNameInProgressMessage,
                }"
              />
              <label
                class="form-check-label"
                for="isShowBrandNameInProgressMessage"
              >
                Show brand name in the progress message
              </label>
              <div
                v-if="isSubmit && error.errorIsShowBrandNameInProgressMessage"
                class="text-error"
              >
                {{ error.errorIsShowBrandNameInProgressMessage.message }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="offset-10 col-2">
              <p class="mb-0">Language</p>
              <multiselect
                v-model="langSelect"
                :options="langOptions"
                label="text"
                track-by="text"
              >
              </multiselect>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="mb-0">
                Membership tier condition ({{ langSelect.text }})
              </p>
              <div v-show="langSelect.text === 'TH'">
                <CkEditor
                  :value="form.membershipTierConditionsTh"
                  :isTh="true"
                  @setContent="setMembershipTierConditionsContent"
                ></CkEditor>
                <div
                  v-if="isSubmit && error.errorMembershipTierConditionsTh"
                  class="text-error"
                >
                  {{ error.errorMembershipTierConditionsTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <CkEditor
                  :value="form.membershipTierConditionsEn"
                  :isTh="false"
                  @setContent="setMembershipTierConditionsContent"
                ></CkEditor>
                <div
                  v-if="isSubmit && error.errorMembershipTierConditionsEn"
                  class="text-error"
                >
                  {{ error.errorMembershipTierConditionsEn.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Contact Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col">
              <p class="mb-0">Line Official Account</p>
              <input
                type="text"
                v-model="form.lineAccount"
                class="form-control"
              />
            </div>
            <div class="col">
              <p class="mb-0">Phone</p>
              <input type="text" v-model="form.phone" class="form-control" />
            </div>
            <div class="col">
              <p class="mb-0">Email</p>
              <input
                type="text"
                v-model="form.email"
                class="form-control"
                :class="{
                  'input--error': isSubmit && error.errorEmail,
                }"
              />
              <div v-if="isSubmit && error.errorEmail" class="text-error">
                {{ error.errorEmail.message }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="mb-0">Address (TH)</p>
              <input
                type="text"
                v-model="form.addressTH"
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="mb-0">Address (EN)</p>
              <input
                type="text"
                v-model="form.addressEN"
                class="form-control"
              />
            </div>
          </div>
          <p class="my-5">
            Contact subject * - ระบุ email addresses โดยใช้ comma คั่น
            กรณีที่มีมากกว่า 1 อีเมล ได้แก่ marketing@shiseido.co.th,
            support@shiseido.co.th
          </p>
          <div v-for="(contact, index) in form.contacts" :key="index">
            <div class="row">
              <div class="col-3 label">{{ contact.subject }}</div>
              <div class="col input-text">
                <input
                  type="text"
                  v-model="contact.email"
                  class="form-control"
                  :class="{
                    'input--error': isSubmit && checkContactErrorExist(contact),
                  }"
                />
                <div v-if="isSubmit">
                  <div
                    v-for="e in error.errorContact"
                    :key="e.contactSubjectId"
                  >
                    <div
                      v-if="e.contactSubjectId === contact.contactSubjectId"
                      class="text-error"
                    >
                      {{ e.message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <router-link
          :to="{ name: 'Brand' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel</router-link
        >
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div class="row">
            <div v-if="showSuccess && queryString.brandCode" class="col-12">
              <button class="btn-back" @click="bindingData()">ตกลง</button>
            </div>
            <div v-if="showSuccess" class="col-12">
              <button
                class="btn-back"
                @click="() => $router.push({ name: 'Brand' })"
              >
                กลับสู่หน้าหลัก
              </button>
            </div>
          </div>
          <div v-if="!showSuccess" class="row">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import BrandService from "@/services/api/brand.service";
import ContactService from "@/services/api/contact.service";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import moment from "moment";
import CkEditor from "components/CkEditor/CkEditor.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";
import DatePicker from "components/Datepicker/Datepicker.vue";

export default {
  components: {DatePicker, NumberInput, CkEditor },
  data() {
    const queryString = this.$route.query;
    return {
      assembledContacts: [],
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      contactSubjects: [],
      pointYearOptions: [],
      queryString,
      form: {
        id: null,
        brandCode: queryString.brandCode,
        brandName: null,
        isActive: true,
        lineAccount: null,
        phone: null,
        email: null,
        addressEN: null,
        addressTH: null,
        contacts: [],
        yearSelect: null,
        isHasPointCollection: false,
        showMembershipCard: false,
        highestStepRequiredForYearEnd: false,
        highestStepRequiredForCatalog: false,
        redemptionStartDate: moment().format("YYYY-MM-DD"),
        redemptionEndDate: moment().format("YYYY-MM-DD"),
        isMembershipVoucherEnabled: false,
        allowLazadaBills: false,
        allowShopeeBills: false,
        allowOfficialWebsiteBills: false,
        lazadaCode: null,
        shopeeCode: null,
        officialWebsiteStoreCode: null,
        officialWebsiteStartDate: null,
        officialWebsiteEndDate: null,
        enableOfficialWebsiteMapping: null,
        officialWebsiteMappingStartDate: null,
        officialWebsiteBrandCode: null,
        logoDisplayOrder: 0,
        logoTargetUrl: null,
        membershipTierStartDate: null,
        membershipTier12MonthRollingStartDate: null,
        isShowBrandNameInProgressMessage: true,
        membershipTierConditionsTh: null,
        membershipTierConditionsEn: null,
        maxAdvanceBookingDays: 0,
        minBookingUpdateHours: 0,
        isBookingBanEnable: false,
        cancelLimitPerPeriod: 0,
        cancelLimitPeriodInDays: 0,
        bookingBanDays: 0,
      },
      error: {
        errorBrandCode: null,
        errorBrandName: null,
        errorStatus: null,
        errorLazadaStoreCode: null,
        errorShopeeStoreCode: null,
        errorOfficialWebsiteStoreCode: null,
        errorOfficialWebsiteStartDate: null,
        errorOfficialWebsiteEndDate: null,
        errorEnableOfficialWebsiteMapping: null,
        errorOfficialWebsiteMappingStartDate: null,
        errorOfficialWebsiteBrandCode: null,
        errorStartDate: null,
        errorEndDate: null,
        errorMembershipVoucherEnabled: null,
        errorEmail: null,
        errorMembershipTierStartDate: null,
        errorMembershipTier12MonthRollingStartDate: null,
        errorContact: [],
        errorIsShowBrandNameInProgressMessage: null,
        errorMembershipTierConditionsTh: null,
        errorMembershipTierConditionsEn: null,
        errorBookingBanDays: null,
        errorCancelLimitPeriodInDays: null,
        errorCancelLimitPerPeriod: null,
        errorMinBookingUpdateHours: null,
        errorMaxAdvanceBookingDays: null,
      },
      redemptionImage: null,
      previewRedemption: null,
      redemptionFile: null,
      logoImage: null,
      previewLogo: null,
      logoFile: null,
      subDirectory: null,
      langOptions: [{ text: "TH" }, { text: "EN" }],
      langSelect: { text: "TH" },
    };
  },
  mounted() {
    if (this.queryString?.brandCode) {
      this.bindingData();
    } else {
      this.getContactSubjects();
    }
    this.setListYear();
  },
  watch: {
    'form.allowOfficialWebsiteBills'(newValue) {
      if (!newValue) {
        this.form.enableOfficialWebsiteMapping = false;
        this.form.officialWebsiteMappingStartDate = null;
        this.form.officialWebsiteBrandCode = null;
      }
    },
  },
  methods: {
    async getContactSubjects() {
      this.isLoading = true;
      try {
        await ContactService.getListContacts()
          .then((res) => {
            this.isLoading = false;
            this.form.contacts = res.data.contactSubjects;
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async bindingData() {
      this.isLoading = true;
      this.showDialog = false;
      try {
        const params = {
          cms: "1",
        };
        await BrandService.getDetailBrand(this.queryString.brandCode, params)
          .then((res) => {
            this.isLoading = false;
            const data = res.data.brand;
            this.form = {
              id: data.id,
              brandCode: data.code,
              brandName: data.name,
              isActive: data.status === "ACTIVE",
              lineAccount: data.lineOA,
              phone: data.phone,
              email: data.email,
              addressTH: data.addressTh,
              addressEN: data.addressEn,
              contacts: data.contactSubjects,
              isHasPointCollection: data.hasPointCollection > 0,
              showMembershipCard: data.showMembershipCard > 0,
              highestStepRequiredForYearEnd: data.highestStepRequiredForYearEnd,
              highestStepRequiredForCatalog: data.highestStepRequiredForCatalog,
              redemptionStartDate: data.startDate
                ? moment(data.startDate, "DD/MM/YYYY").format("YYYY-MM-DD")
                : moment().format("YYYY-MM-DD"),
              redemptionEndDate: data.endDate
                ? moment(data.endDate, "DD/MM/YYYY").format("YYYY-MM-DD")
                : moment().format("YYYY-MM-DD"),
              yearSelect: data.pointYear,
              isMembershipVoucherEnabled: data.isMembershipVoucherEnabled !== 0,
              allowLazadaBills: data.allowLazadaBills,
              allowShopeeBills: data.allowShopeeBills,
              allowOfficialWebsiteBills: data.allowOfficialWebsiteBills,
              lazadaCode: data.lazadaStoreCode,
              shopeeCode: data.shopeeStoreCode,
              officialWebsiteStartDate: data.officialWebsiteStartDate
                ? moment(
                    data.officialWebsiteStartDate,
                    "YYYY-MM-DDTHH:mm:ssZ"
                  ).format("YYYY-MM-DD")
                : null,
              officialWebsiteEndDate: data.officialWebsiteEndDate
                ? moment(
                    data.officialWebsiteEndDate,
                    "YYYY-MM-DDTHH:mm:ssZ"
                  ).format("YYYY-MM-DD")
                : null,
              officialWebsiteStoreCode: data.officialWebsiteStoreCode,
              enableOfficialWebsiteMapping: data.enableOfficialWebsiteMapping,
              officialWebsiteMappingStartDate: data.officialWebsiteMappingStartDate
                  ? moment(
                      data.officialWebsiteMappingStartDate,
                      "YYYY-MM-DD"
                  ).format("YYYY-MM-DD")
                  : null,
              officialWebsiteBrandCode: data.officialWebsiteBrandCode,
              logoDisplayOrder: data.logoDisplayOrder,
              logoTargetUrl: data.logoTargetUrl,
              membershipTierStartDate: data.membershipTierStartDate
                ? moment(
                    data.membershipTierStartDate,
                    "YYYY-MM-DDTHH:mm:ssZ"
                  ).format("YYYY-MM-DD")
                : moment().format("YYYY-MM-DD"),
              membershipTier12MonthRollingStartDate:
                data.membershipTier12MonthRollingStartDate
                  ? moment(
                      data.membershipTier12MonthRollingStartDate,
                      "YYYY-MM-DDTHH:mm:ssZ"
                    ).format("YYYY-MM-DD")
                  : moment().format("YYYY-MM-DD"),
              isShowBrandNameInProgressMessage:
                data.isShowBrandNameInProgressMessage,
              membershipTierConditionsTh: data.membershipTierConditionsTh,
              membershipTierConditionsEn: data.membershipTierConditionsEn,
              maxAdvanceBookingDays: data.maxAdvanceBookingDays,
              minBookingUpdateHours: data.minBookingUpdateHours,
              isBookingBanEnable: data.isBookingBanEnable,
              cancelLimitPerPeriod: data.cancelLimitPerPeriod,
              cancelLimitPeriodInDays: data.cancelLimitPeriodInDays,
              bookingBanDays: data.bookingBanDays,
            };
            this.redemptionImage = data.redemptionMenuImage;
            this.previewRedemption = data.redemptionMenuImageUrl;
            this.logoImage = data.logoImage;
            this.previewLogo = data.logoImageUrl;
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async addOrEditBrand(body, isUpdate = false) {
      this.isLoading = true;
      try {
        await BrandService.createOrUpdateBrand(
          body,
          this.queryString.brandCode,
          isUpdate
        )
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            if (data.message) {
              this.message = data.message;
              this.showDialog = true;
            }
            if (data.status === "failure") {
              this.setErrorText(data.errors);
            } else {
              this.resetErrorText();
              this.showSuccess = true;
            }
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async uploadRedemptionImage(e) {
      this.isLoading = true;
      if (e.target.files) {
        this.redemptionFile = e.target.files[0];
        this.previewRedemption = URL.createObjectURL(this.redemptionFile);
        await this.getS3URL(this.redemptionFile);
      }
    },
    async uploadLogoImage(e) {
      this.isLoading = true;
      if (e.target.files) {
        this.logoFile = e.target.files[0];
        this.previewLogo = URL.createObjectURL(this.logoFile);
        await this.getS3URL(this.logoFile);
      }
    },
    async getS3URL(file) {
      if (file === this.redemptionFile) {
        this.subDirectory = "brand";
      } else if (file === this.logoFile) {
        this.subDirectory = "brand/logo";
      }
      await PresignedUploadUrlService.getS3SignUrl(this.subDirectory, file)
        .then((res) => {
          const data = res.data;
          if (data.status === "failure") {
            this.isLoading = false;
            this.showDialog = true;
            this.message = data.message;
          } else {
            if (file === this.redemptionFile) {
              this.redemptionImage = data.key;
            } else if (file === this.logoFile) {
              this.logoImage = data.key;
            }
            this.pushImageToS3(data.presignedUrl, file);
          }
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async pushImageToS3(presignedUrl, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(presignedUrl, file);
      this.isLoading = false;
    },
    deleteRedemptionImage() {
      this.redemptionImage = null;
      this.previewRedemption = null;
      this.$refs.redempImageFile.value = null;
      this.redemptionFile = null;
    },
    deleteLogoImage() {
      this.logoImage = null;
      this.previewLogo = null;
      this.$refs.logoImageFile.value = null;
      this.logoFile = null;
    },
    setListYear() {
      const currentYear = moment().year();
      for (let i = currentYear; i > 1980; i--) {
        this.pointYearOptions.push(i);
      }
    },
    assembleContactList() {
      this.assembledContacts = this.form.contacts.map((i) => {
        return {
          contactSubjectId: i.contactSubjectId,
          email: i.email,
        };
      });
    },
    setMembershipTierConditionsContent(content, isTh = true) {
      if (isTh) {
        this.form.membershipTierConditionsTh = content || "";
      } else {
        this.form.membershipTierConditionsEn = content || "";
      }
    },
    setErrorText(errors) {
      this.error.errorBrandCode = errors.find(
        (e) => e.fieldName === "brandCode"
      );
      this.error.errorBrandName = errors.find(
        (e) => e.fieldName === "brandName"
      );
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorLazadaStoreCode = errors.find(
        (e) => e.fieldName.trim() === "lazadaStoreCode"
      );
      this.error.errorShopeeStoreCode = errors.find(
        (e) => e.fieldName.trim() === "shopeeStoreCode"
      );
      this.error.errorOfficialWebsiteStoreCode = errors.find(
        (e) => e.fieldName.trim() === "officialWebsiteStoreCode"
      );
      this.error.errorOfficialWebsiteStartDate = errors.find(
        (e) => e.fieldName.trim() === "officialWebsiteStartDate"
      );
      this.error.errorOfficialWebsiteEndDate = errors.find(
        (e) => e.fieldName.trim() === "officialWebsiteEndDate"
      );
      this.error.errorEnableOfficialWebsiteMapping = errors.find(
          (e) => e.fieldName.trim() === "enableOfficialWebsiteMapping"
      );
      this.error.errorOfficialWebsiteMappingStartDate = errors.find(
          (e) => e.fieldName.trim() === "officialWebsiteMappingStartDate"
      );
      this.error.errorOfficialWebsiteBrandCode = errors.find(
          (e) => e.fieldName.trim() === "errorOfficialWebsiteBrandCode"
      );
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorMembershipVoucherEnabled = errors.find(
        (e) => e.fieldName === "isMembershipVoucherEnabled"
      );
      this.error.errorEmail = errors.find((e) => e.fieldName === "email");
      this.error.errorMembershipTierStartDate = errors.find(
        (e) => e.fieldName === "membershipTierStartDate"
      );
      this.error.errorMembershipTier12MonthRollingStartDate = errors.find(
        (e) => e.fieldName === "membershipTier12MonthRollingStartDate"
      );
      this.error.errorContact = errors.filter((e) => e.fieldName === "contact");
      this.error.errorBookingBanDays = errors.find(
        (e) => e.fieldName.trim() === "bookingBanDays"
      );
      this.error.errorCancelLimitPeriodInDays = errors.find(
        (e) => e.fieldName.trim() === "cancelLimitPeriodInDays"
      );
      this.error.errorCancelLimitPerPeriod = errors.find(
        (e) => e.fieldName.trim() === "cancelLimitPerPeriod"
      );
      this.error.errorMinBookingUpdateHours = errors.find(
        (e) => e.fieldName.trim() === "minBookingUpdateHours"
      );
      this.error.errorMaxAdvanceBookingDays = errors.find(
        (e) => e.fieldName.trim() === "maxAdvanceBookingDays"
      );
    },
    resetErrorText() {
      this.error = {
        errorBrandCode: null,
        errorBrandName: null,
        errorStatus: null,
        errorLazadaStoreCode: null,
        errorShopeeStoreCode: null,
        errorOfficialWebsiteStoreCode: null,
        errorOfficialWebsiteStartDate: null,
        errorOfficialWebsiteEndDate: null,
        errorEnableOfficialWebsiteMapping: null,
        errorEnableOfficialWebsiteStartDate: null,
        errorOfficialWebsiteBrandCode: null,
        errorStartDate: null,
        errorEndDate: null,
        errorMembershipVoucherEnabled: null,
        errorEmail: null,
        errorMembershipTierStartDate: null,
        errorMembershipTier12MonthRollingStartDate: null,
        errorContact: [],
        errorIsShowBrandNameInProgressMessage: null,
        errorMembershipTierConditionsTh: null,
        errorMembershipTierConditionsEn: null,
        errorBookingBanDays: null,
        errorCancelLimitPeriodInDays: null,
        errorCancelLimitPerPeriod: null,
        errorMinBookingUpdateHours: null,
        errorMaxAdvanceBookingDays: null,
      };
    },
    checkContactErrorExist(contact) {
      return this.error.errorContact.find(
        (e) => e.contactSubjectId === contact.contactSubjectId
      );
    },
    onSubmit() {
      this.isSubmit = true;
      const form = this.form;
      this.showSuccess = false;
      this.assembleContactList();
      const body = {
        brandName: form.brandName,
        lineOA: form.lineAccount,
        phone: form.phone,
        email: form.email,
        addressTh: form.addressTH,
        addressEn: form.addressEN,
        status: form.isActive ? "ACTIVE" : "INACTIVE",
        contact: this.assembledContacts,
        startDate: moment(form.redemptionStartDate).format("DD/MM/YYYY"),
        endDate: moment(form.redemptionEndDate).format("DD/MM/YYYY"),
        hasPointCollection: form.isHasPointCollection ? 1 : 0,
        showMembershipCard: form.showMembershipCard ? 1 : 0,
        highestStepRequiredForYearEnd: form.highestStepRequiredForYearEnd,
        highestStepRequiredForCatalog: form.highestStepRequiredForCatalog,
        pointYear: Number.parseInt(form.yearSelect),
        redemptionMenuImage: this.redemptionImage,
        isMembershipVoucherEnabled: form.isMembershipVoucherEnabled ? 1 : 0,
        logoDisplayOrder: form.logoDisplayOrder,
        logoTargetUrl: form.logoTargetUrl,
        logoImage: this.logoImage,
        membershipTierStartDate: form.membershipTierStartDate
          ? moment(form.membershipTierStartDate).format("DD/MM/YYYY")
          : null,
        membershipTier12MonthRollingStartDate:
          form.membershipTier12MonthRollingStartDate
            ? moment(form.membershipTier12MonthRollingStartDate).format(
                "DD/MM/YYYY"
              )
            : null,
        isShowBrandNameInProgressMessage: form.isShowBrandNameInProgressMessage,
        membershipTierConditionsTh: form.membershipTierConditionsTh,
        membershipTierConditionsEn: form.membershipTierConditionsEn,
        maxAdvanceBookingDays:
          form.maxAdvanceBookingDays === "" ? null : form.maxAdvanceBookingDays,
        minBookingUpdateHours:
          form.minBookingUpdateHours === "" ? null : form.minBookingUpdateHours,
        isBookingBanEnable: form.isBookingBanEnable ?? false,
        cancelLimitPerPeriod:
          form.cancelLimitPerPeriod === "" ? null : form.cancelLimitPerPeriod,
        cancelLimitPeriodInDays:
          form.cancelLimitPeriodInDays === ""
            ? null
            : form.cancelLimitPeriodInDays,
        bookingBanDays: form.bookingBanDays === "" ? null : form.bookingBanDays,
        ...this.buildOnlineStoresData(form),
      };
      let query = this.$route.query;
      if (query?.brandCode) {
        this.addOrEditBrand(body, true);
      } else {
        body.brandCode = form.brandCode;
        this.addOrEditBrand(body);
      }
    },
    buildOnlineStoresData(form) {
      return {
        allowLazadaBills: form.allowLazadaBills,
        allowShopeeBills: form.allowShopeeBills,
        allowOfficialWebsiteBills: form.allowOfficialWebsiteBills,
        lazadaStoreCode: form.lazadaCode,
        shopeeStoreCode: form.shopeeCode,
        officialWebsiteStoreCode: form.officialWebsiteStoreCode,
        officialWebsiteStartDate: form.officialWebsiteStartDate
            ? moment(form.officialWebsiteStartDate).format("DD/MM/YYYY")
            : null,
        officialWebsiteEndDate: form.officialWebsiteEndDate
            ? moment(form.officialWebsiteEndDate).format("DD/MM/YYYY")
            : null,
        enableOfficialWebsiteMapping: form.enableOfficialWebsiteMapping,
        officialWebsiteMappingStartDate: form.officialWebsiteMappingStartDate
            ? moment(form.officialWebsiteMappingStartDate).format("YYYY-MM-DD")
            : null,
        officialWebsiteBrandCode: form.officialWebsiteBrandCode,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.btn {
  margin: 3rem 0;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}
.point-year-select {
  margin-top: 12px;
}
.content-dialog {
  height: 330px;
  background: #fff;
  overflow: hidden;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}

.information-title-wrapper {
  background-color: #2a2a2e;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.information-title {
  font-weight: 600;
  font-size: 17px;
  padding: 14px;
  color: #dcdcdc;
}

.information-group {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px, rgba(0, 0, 0, 0.22) 0 2px 2px;
}
</style>
